import { ReactNode } from 'react';

export enum QuestionType {
    single = 1, // 单选
    multiply = 2, // 多选
    judge = 3,
    gapFill = 4,
    comprehensive = 5,
    shortAnswer = 6,
    noDirection = 7, // 不定向
    cloze = 58, // 完型题
}

export enum QuestionAnswerMode {
    text = 0,
    word = 1,
    excel = 2,
    excelAndText = 3,
    textAndExcel = 4,
    excelLucky = 5,
}

export interface QuestionReviewObjectItem {
    children: QuestionReviewObjectItem[];
    content: string; // 回答内容
    keyWordId: number; // 匹配到的关键词id
    matchStatus: number; // 匹配类型 0：不匹配， 1：匹配
    score: number; // 得分
    sentenceIds: number[]; // 用户答案分句id
}

export interface IQuestionListItemQuestionAnswer {
    analysis: string;
    answer: string | number;
    audioUrl: string;
    questionId: number;
    translate: string;
    videoUrl: string;
    improve: string; // 拔高模块
    questionVideo: {
        encryptType: string;
        sourceId: string;
        vid: string;
    };
    clozeAnswers: {
        answerContent: string;
        key: string;
        rightAnswer: string;
        type: string;
    }[];
}

export interface IQuestionListItemUserAnswer {
    userAnswerStatus: number; // 用户答题状态 0没有回答; 1 正确; 2回答错误; 3半对; 4填空题
    questionId: number; // 题目id
    userAnswer: string | number; // 用户答案
    userAnswerImagesList?: string[]; // 用户答案图片
    excelAnswer?: string; // excel答案
    userScore?: number; // 无
    questionReviewObject?: QuestionReviewObjectItem; // 用户答案拆分及得分点
    exceedPercent?: string; // 超过多少人文案
    costTime?: number; // 答题时长
    userClozeAnswers?: {
        key: string;
        rightAnswer: string;
        userAnswer: string;
        answerContent: string;
        userAnswerStatus: number;
    }[];
    correctStatus?: number; // 0 1 2 未批改，进行中， 已批改
    correctFileUrl?: string; // 批阅文件地址
    blankAiCorrectOpen?: number; // 0 普通批改，1 ai批改
}

export interface ICorrectAccountCategory {
    correctAccountList: {
        /** 借 */
        borrowList: IBorrowOrLoanItem[]; // 类型：Array  必有字段  备注：借
        /** 贷 */
        loanList: IBorrowOrLoanItem[]; // 类型：Array  必有字段  备注：贷
        userScore: number; // 类型：Number  必有字段  备注：得分
    }[];
    userScore: number; // 得分
    questionScore: number; // 总分
}

// 借or贷 item
export interface IBorrowOrLoanItem {
    amountNum: number; // 类型：Number  必有字段  备注：金额
    correctResult: number; // 类型：Number  必有字段  备注：批改结果 number正确得分 number错误不得分 number其他
    subjectName: string; // 类型：String  必有字段  备注：科目名称
    userScore: number; // 类型：Number  必有字段  备注：得分
}

export interface ICorrectText {
    correctPointList: {
        // 类型：Object  必有字段  备注：无
        answer: string; // 类型：String  必有字段  备注：学员答案
        score: number; // 类型：Number  必有字段  备注：得分（number分表示不得分）
        /** 该得分点展示状态，0：（红色字体），1：（绿色字体），2：（黑色字体） */
        showStatus: number; //
    }[];
    userScore: number; // 得分
    questionScore: number; // 总分
}

export interface ICorrectType {
    answerType: 'text' | 'table' | 'category'; // 回答类型
    correctText?: ICorrectText;
    correctAccountCategory?: ICorrectAccountCategory;
    correctTable?: ICorrectTable;
}

export interface IQuestionListItem {
    answerMode: number;
    excelAnswerContent: string;
    questionId: number; // 题目id
    questionUuid?: number;
    title: string; // 题干
    titleAudio: string; // 音频数据
    parentQuestionId: number;
    questionType: QuestionType; // 题型（1：单选题 2： 多选题 3：判断题 4：填空题 5：综合题 6：简答题 7：不定项选择题）
    option: string; // 选项（优先使用selectList,无selectList使用option）
    optionNum: number; // 选项个数
    sortNum: number | string; //
    selectList: {
        id: number; // 选项的id
        questionId: number; // 题目id
        content: string; // 选项内容
        option: string; // 选项
    }[]; // 选项（可能为空，为空时，优先使用selectList,无selectList使用option）
    projectId: number; // 项目id
    subjectId: number; // 科目id
    twoLevelSubjectId: number; // 类级科目id
    userAnswer?: IQuestionListItemUserAnswer;
    subQuestionList: IQuestionListItem[];
    questionAnswer?: IQuestionListItemQuestionAnswer;
    knowledgePointList?: {
        // 题目关联的知识点列表
        id: number;
        isdel: number;
        status: number;
        title: string;
        projectId: number;
        subjectId: number;
        examSeasonId: number; // 考季id
    }[];
    rank?: number;
    score?: number;
    questionCount?: {
        // 题目的统计信息
        correctRate: string; // 全站正确率（百分百字符串）
        finishNum: number; // 完成答题数
        rightNum: number; // 正确数
    };
    artificialIntelligence: number; // 1是 ai批阅的简答题
    clozeQuestionNum: number; // 玩形题需要做的空的数量
    aiCorrect?: {
        aiBotType: number;
        cpaBotType: number;
        aiErrorTotalScore: number;
        aiTutorConfigId: number; // 场景id
        botId: string;
        /** 0: 未批改，1，批改中， */
        correctStatus: number; // 批阅状态
        suggest: string;
        summary: string;
        totalScore: number;
        totalScoreStr: number;
        pointList: { answer: string; score: number; content: string[] }[];
        id: number; // 批改id
        corrects: ICorrectType[];
    };
    questionSeaClozeContent: {
        key: string;
        type: 'text' | 'input' | 'select' | 'table' | 'radioTable' | 'picture';
        content: string;
        inputQuestion: {
            rightAnswer: string;
            weight: number;
        };
        selectList: {
            weight: number;
            rightAnswer: string;
            options: {
                label: string;
                value: string;
            }[];
        };
        tableInfo: {
            col: number;
            row: number;
            width: number;
            tableList: {
                key: string;
                childList: IQuestionListItem['questionSeaClozeContent'];
            }[];
        };
        radioTableInfo: {
            row: number;
            col: number;
            dataList: {
                key: string;
                label: string;
                value: string;
            }[];
            questionListInfo: {
                answerContent: string;
                key: string;
                rightAnswer: string;
                title: string;
                userAnswer: null;
            }[];
        };
        picture: {
            height: number;
            link: string;
            scale: number;
            width: number;
        };
    }[];
}

export interface NoteItem {
    fabulousNum: number; // 点赞数量
    isFabulous: boolean; // 是否
    noteContent: string; // 笔记内容
    noteId: number; // 笔记id
    noteState: number; // 笔记状态 0状态 1公开
    paperDataId: number; // gd_paper_data id
    questionId: number; // 题目id
    studentId: number; // 学生id
    studentImage: string; // 头像
    studentName: string; // 学生姓名
    isSelf: boolean; // 是否是本人笔记
}

export interface WordItem {
    wordId: number;
    englishWord: string;
    chineseWord: string;
    chineseSubtitle: string;
    englishSubtitle: string;
    projectId: number;
}

export interface QuestionExtraInfo {
    isFavorite: boolean; // 类型：Boolean  必有字段  备注：无
    pastPaperList: {
        paperId: number; // ：试卷id
        paperName: string; // 试卷名称
    }[]; // 类型：Array  可有字段  备注：真题卷（来源）列表
}

export type IQuestionActions = {
    parentId?: number;
    questionItem: IQuestionListItem;
    isAnalysis?: boolean;
    children?: ReactNode;
    removeCollect?: boolean;
    removeLucaAnswer?: boolean;
};

export interface ICellDataType {
    v: {
        v?: string | number | null;
        m?: string;
        ht?: string;
        mc?: {
            r: number;
            c: number;
            rs?: number;
            cs?: number;
        };
    };
    r: number;
    c: number;
    cellType: number | null; // 单元格类型：0：过程,1：关键数字,2:项目分类
    status: number; // 批改状态：0-无需批改；1-0分；2-已批改；3-已批改（但解析失败）
    correct: {
        answerType: 'text' | 'table' | 'category'; // 回答类型
        score: number;
        correctPointList: {
            answer: string;
            score: number;
            /** 该得分点展示状态，0：（红色字体），1：（绿色字体），2：（黑色字体） */
            showStatus: number;
        }[];
    } | null;
}

export interface ICorrectTable {
    row: number;
    tableStatus: number; // 批改状态：2-已批改（默认状态）；5-缺乏计算过程（当缺乏计算过程）
    cellData: ICellDataType[];
    col: number;
    userScore: number; // 得分
    questionScore: number; // 总分
}
